import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from 'core'
import { PageURLs } from 'Routes'

/**
 * PrivateRoute — redirects to login only when the user is NOT authenticated.
 * Used exclusively on auth-gated pages: checkout, profile, settings, order history.
 * Product browsing, home, search, cart preview, and wishlist viewing are all public.
 */
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loadingAuth } = useAuth()
  const location = useLocation()

  // Still loading auth state — render nothing to prevent flash
  if (loadingAuth) return null

  if (!isAuthenticated) {
    return <Navigate to={PageURLs.Login} state={{ from: location }} replace />
  }

  return children
}

export default PrivateRoute
